import { createElementBlock, defineComponent, openBlock, renderSlot } from "vue";
//#region src/components/HelpfulLink.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = ["href"];
var HelpfulLink_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "HelpfulLink",
	props: { href: {} },
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("a", {
				class: "decoration-c-3 cursor-help underline underline-offset-2",
				href: __props.href,
				rel: "noopener noreferrer",
				target: "_blank"
			}, [renderSlot(_ctx.$slots, "default")], 8, _hoisted_1);
		};
	}
});
//#endregion
export { HelpfulLink_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=HelpfulLink.vue_vue_type_script_setup_true_lang.js.map